module.exports = __webpack_public_path__ + "static/media/qa-icon.9439c8fc.png";